export const DragIcon = (props) => (
  <svg
    {...props}
    width={20}
    height={20}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.707 10.293a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L8 12.586l-2.293-2.293zM10.293 5.707a1 1 0 1 0 1.414-1.414l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L8 3.414l2.293 2.293z"
      fill="var(--text-primary)"
    />
  </svg>
);
